import CloseIcon from "assets/svg/close.svg";
import WarningIcon from "assets/svg/warning.svg";
import React, { FC, useEffect, useState } from "react";

import styles from "./style.module.css";

type Props = {
  classes: string;
  spaces: string;
  type: "VIDEO" | "HOME" | "LOGIN";
  text: string;
};

const HalfPriceTraffic: FC<Props> = ({ classes, spaces, type, text }) => {
  const [isDisplayable, setIsDisplayable] = useState(true);
  const onClose = () => {
    if (type === "HOME") {
      if (typeof window !== "undefined") {
        const isHalfPriceTraffic = localStorage.getItem("isHalfPriceTraffic");
        if (!isHalfPriceTraffic) {
          localStorage.setItem("isHalfPriceTraffic", "1");
        }
      }
    }
    setIsDisplayable(false);
  };
  return (
    <>
      {isDisplayable ? (
        <div
          className={`py-[.2rem] px-0 md:py-[.6rem] ${
            styles.container
          } ${classes} ${type !== "VIDEO" && "relative"}`}
        >
          <div
            className={`${spaces} !pl-4 text-center text-[0.7rem] md:!pl-6 md:text-base`}
          >
            <WarningIcon className="ml-2 inline-block w-[.9rem] md:w-[auto]" />
            <span className="text-right">{text}</span>
            {type !== "LOGIN" && (
              <button
                onClick={onClose}
                aria-label="close banner"
                className="absolute top-[5%] left-[.1rem] h-[1.4rem] w-[1.4rem] md:top-[12%] md:left-[.1rem] md:h-[2rem] md:w-[2rem]"
              >
                <CloseIcon className="inline-block w-[.6rem] md:w-[auto]" />
              </button>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default HalfPriceTraffic;
